module.exports = __webpack_public_path__ + "img/packages.04812fce.png";